class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.preventScroll = this.preventBackgroundScroll.bind(this);
    this.scrollPosition = 0;
    this.overlay = this.querySelector('.cart-notification__overlay') || document.createElement('button');
    this.overlay.type = 'button';
    this.overlay.className = 'cart-notification__overlay';
    this.overlay.setAttribute('aria-label', window.accessibilityStrings?.close || 'Close');
    this.overlay.hidden = true;
    if (!this.overlay.parentElement) this.prepend(this.overlay);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.scrollToTopForNotification();
    this.overlay.hidden = false;
    this.setAttribute('data-open', 'true');
    this.lockPageScroll();
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.overlay.hidden = true;
    this.removeAttribute('data-open');
    this.unlockPageScroll();
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  scrollToTopForNotification() {
    const supportsReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    try {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: supportsReducedMotion ? 'auto' : 'instant',
      });
    } catch {
      window.scrollTo(0, 0);
    }

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  lockPageScroll() {
    if (document.body.classList.contains('cart-notification-lock')) return;

    this.scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('cart-notification-lock');
    document.body.classList.add('cart-notification-lock');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    document.addEventListener('touchmove', this.preventScroll, { passive: false });
    document.addEventListener('wheel', this.preventScroll, { passive: false });
  }

  unlockPageScroll() {
    const scrollPosition = this.scrollPosition || Math.abs(parseInt(document.body.style.top || '0', 10)) || 0;

    document.removeEventListener('touchmove', this.preventScroll);
    document.removeEventListener('wheel', this.preventScroll);
    document.documentElement.classList.remove('cart-notification-lock');
    document.body.classList.remove('cart-notification-lock');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, scrollPosition);
  }

  preventBackgroundScroll(event) {
    if (!this.notification.classList.contains('active')) return;

    const scrollablePanel = event.target.closest?.('#cart-notification');
    if (scrollablePanel && scrollablePanel.scrollHeight > scrollablePanel.clientHeight) return;

    event.preventDefault();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
